export var SapUpgradePhase;
(function (SapUpgradePhase) {
    SapUpgradePhase["SAP_UPGRADE_PHASE_IDLE"] = "IDLE";
    SapUpgradePhase["SAP_UPGRADE_PHASE_REQUESTED"] = "REQUESTED";
    SapUpgradePhase["SAP_UPGRADE_PHASE_DOWNLOADING"] = "DOWNLOADING";
    SapUpgradePhase["SAP_UPGRADE_PHASE_DRAINING"] = "DRAINING";
    SapUpgradePhase["SAP_UPGRADE_PHASE_STAGED"] = "STAGED";
    SapUpgradePhase["SAP_UPGRADE_PHASE_SWAPPED"] = "SWAPPED";
    SapUpgradePhase["SAP_UPGRADE_PHASE_AWAITING_ROLLOUT"] = "AWAITING_ROLLOUT";
    SapUpgradePhase["SAP_UPGRADE_PHASE_FAILED"] = "FAILED";
    SapUpgradePhase["SAP_UPGRADE_PHASE_ROLLED_BACK"] = "ROLLED_BACK";
})(SapUpgradePhase || (SapUpgradePhase = {}));
